import { useSelector } from "react-redux";
import { ACCOUNT_ENUMS } from "../constants";

export const ProfileInfo = () => {
  const selector = useSelector((state) => state?.auth?.myProfile);
  const accessToke = useSelector((state) => state?.auth?.accessToke);

  const userType = localStorage.getItem("userType");

  const local =
    localStorage.getItem("userInfo") &&
    JSON.parse(localStorage.getItem("userInfo"));
  const myProfile = selector || local;

  const localToken = localStorage.getItem("access-token");
  const token = localToken || accessToke;

  const ifAdmin = userType === ACCOUNT_ENUMS.ADMIN;
  const ifCharity = userType === ACCOUNT_ENUMS.CHARITY;
  return { myProfile, token, ifAdmin, ifCharity, userType };
};
